import { toast } from "react-toastify";
import { with_auth } from "src/adapter";
import adapter from "src/adapter/header";
import { errorSWAL } from "src/components/SweetAlert";
import {
  ADD_COMPANY_FAIL,
  ADD_COMPANY_REQUEST,
  ADD_COMPANY_SUCCESS,
  ADD_OPERATOR_COMPANY_FAIL,
  ADD_OPERATOR_COMPANY_REQUEST,
  ADD_OPERATOR_COMPANY_SUCCESS,
  ADD_PUBLIC_COMPANY_FAIL,
  ADD_PUBLIC_COMPANY_REQUEST,
  ADD_PUBLIC_COMPANY_SUCCESS,
  CREATE_TELEGRAM_CHANNEL_FAIL,
  CREATE_TELEGRAM_CHANNEL_REQUEST,
  CREATE_TELEGRAM_CHANNEL_SUCCESS,
  DELETE_COMPANY_FAIL,
  DELETE_COMPANY_REQUEST,
  DELETE_COMPANY_SUCCESS,
  EDIT_COMPANY_STATUS_FAIL,
  EDIT_COMPANY_STATUS_REQUEST,
  EDIT_COMPANY_STATUS_SUCCESS,
  GET_COMPANY_FAIL,
  GET_COMPANY_LIST,
  GET_COMPANY_SUCCESS,
  GET_OPERATOR_COMPANY_FAIL,
  GET_OPERATOR_COMPANY_LIST,
  GET_OPERATOR_COMPANY_SUCCESS,
  GET_SINGLE_COMPANY_FAIL,
  GET_SINGLE_COMPANY_REQUEST,
  GET_SINGLE_COMPANY_SUCCESS,
  REFRESH_MOBILE_AUTHORIZE_TOKEN_FAIL,
  REFRESH_MOBILE_AUTHORIZE_TOKEN_REQUEST,
  REFRESH_MOBILE_AUTHORIZE_TOKEN_SUCCESS,
  UPDATE_COMPANY_FAIL,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
} from "src/constants/types";
import i18n from "src/i18n";

export const createTelegramChannel = (data) => async (dispatch) => {
  dispatch({ type: CREATE_TELEGRAM_CHANNEL_REQUEST });
  try {
    const result = await adapter({
      url: `/company/create-telegram-channel`,
      method: "POST",
      data,
      headers: with_auth(),
    });

    dispatch({ type: CREATE_TELEGRAM_CHANNEL_SUCCESS, payload: result });

    return Promise.resolve(result.Data?.Message);
  } catch (e) {
    dispatch({ type: CREATE_TELEGRAM_CHANNEL_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const getOperatorCompanyList =
  ({ PageNumber = 1, PageSize = 25, Name = "" } = {}) =>
    async (dispatch) => {
      dispatch({ type: GET_OPERATOR_COMPANY_LIST });

      try {
        const result = await adapter({
          url: `/company/operator-company`,
          method: "GET",
          params: {
            PageSize,
            PageNumber,
            Name,
          },
        });

        dispatch({ type: GET_OPERATOR_COMPANY_SUCCESS, payload: result.Data });
      } catch (e) {
        dispatch({ type: GET_OPERATOR_COMPANY_FAIL, payload: e.data.Status });
        errorSWAL({
          text:
            e.data && e.data.Status && e.data.Status.Message
              ? e.data.Status.Message
              : i18n.t("swal.error"),
          confirmButtonText: i18n.t("utils.ok"),
        });
      }
    };




export const getCompanyList =
  ({
    pageNumber = 1,
    pageSize = 25,
    name = "",
    statusId = "",
    companyTypeId = "2",
    externalCode = "",
  } = {}) =>
    async (dispatch) => {
      dispatch({ type: GET_COMPANY_LIST });

      try {
        const result = await adapter({
          url: `/company`,
          method: "GET",
          headers: with_auth(),
          params: {
            PageSize: pageSize,
            PageNumber: pageNumber,
            Name: name,
            StatusId: statusId,
            // CompanyTypeId: companyTypeId,
            ExternalCode: externalCode,
          },
        });

        dispatch({ type: GET_COMPANY_SUCCESS, payload: result.Data });
      } catch (e) {
        dispatch({ type: GET_COMPANY_FAIL, payload: e.data.Status });
        errorSWAL({
          text:
            e.data && e.data.Status && e.data.Status.Message
              ? e.data.Status.Message
              : i18n.t("swal.error"),
          confirmButtonText: i18n.t("utils.ok"),
        });
      }
    };

export const getOriginalCompanyList =
  ({
    pageNumber = 1,
    pageSize = 25,
    name = "",
    statusId = "",
    companyTypeId = "",
    externalCode = "",
  } = {}) =>
    async (dispatch) => {
      dispatch({ type: GET_COMPANY_LIST });

      try {
        const result = await adapter({
          url: `/company`,
          method: "GET",
          headers: with_auth(),
          params: {
            PageSize: pageSize,
            PageNumber: pageNumber,
            Name: name,
            StatusId: statusId,
            CompanyTypeId: companyTypeId,
            ExternalCode: externalCode,
          },
        });

        dispatch({ type: GET_COMPANY_SUCCESS, payload: result.Data });
      } catch (e) {
        dispatch({ type: GET_COMPANY_FAIL, payload: e.data.Status });
        errorSWAL({
          text:
            e.data && e.data.Status && e.data.Status.Message
              ? e.data.Status.Message
              : i18n.t("swal.error"),
          confirmButtonText: i18n.t("utils.ok"),
        });
      }
    };

export const getSingleCompany = (id) => async (dispatch) => {
  dispatch({ type: GET_SINGLE_COMPANY_REQUEST });

  try {
    const result = await adapter({
      url: `/company/${id}`,
      method: "GET",
      headers: with_auth(),
    });

    dispatch({
      type: GET_SINGLE_COMPANY_SUCCESS,
      payload: result.Data.Company,
    });
  } catch (e) {
    dispatch({ type: GET_SINGLE_COMPANY_FAIL, payload: e.data.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  }
};

export const updateCompany = (data) => async (dispatch) => {
  dispatch({ type: UPDATE_COMPANY_REQUEST });
  try {
    await adapter({
      url: `/company`,
      method: "PUT",
      data: data,
      headers: with_auth(),
    }).then((res) =>
      toast.success(i18n.t("swal.edit"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
      })
    );
    dispatch({ type: UPDATE_COMPANY_SUCCESS });
    return Promise.resolve();
  } catch (e) {
    dispatch({ type: UPDATE_COMPANY_FAIL, payload: e.data.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const editCompanyAiToken = (data) => async (dispatch) => {
  try {
    await adapter({
      url: `/company/edit-ai-token`,
      method: "PUT",
      data,
      headers: with_auth(),
    });
    toast.success(i18n.t("swal.edit"), {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
    });
    return Promise.resolve();
  } catch (e) {
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const addOperatorCompany = (data) => async (dispatch) => {
  dispatch({ type: ADD_OPERATOR_COMPANY_REQUEST });
  try {
    const result = await adapter({
      url: `/company/add-operator-company`,
      method: "POST",
      data: data,
    });
    dispatch({ type: ADD_OPERATOR_COMPANY_SUCCESS, payload: result });

    return Promise.resolve();
  } catch (e) {
    dispatch({ type: ADD_OPERATOR_COMPANY_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const addPublicCompany = (data) => async (dispatch) => {
  dispatch({ type: ADD_PUBLIC_COMPANY_REQUEST });
  try {
    const result = await adapter({
      url: `/company/add-company`,
      method: "POST",
      data: data,
    });
    dispatch({ type: ADD_PUBLIC_COMPANY_SUCCESS, payload: result });

    return Promise.resolve();
  } catch (e) {
    dispatch({ type: ADD_PUBLIC_COMPANY_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const editCompanyStatus = (data) => async (dispatch) => {
  dispatch({ type: EDIT_COMPANY_STATUS_REQUEST });
  try {
    const result = await adapter({
      url: `/company/edit-status`,
      method: "POST",
      data: data,
      headers: with_auth(),
    });
    dispatch({ type: EDIT_COMPANY_STATUS_SUCCESS, payload: result });

    toast.success(i18n.t("swal.success"), {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });

    return Promise.resolve();
  } catch (e) {
    dispatch({ type: EDIT_COMPANY_STATUS_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const addNewCompany = (data) => async (dispatch) => {
  dispatch({ type: ADD_COMPANY_REQUEST });
  try {
    const result = await adapter({
      url: `/company`,
      method: "POST",
      data: data,
      headers: with_auth(),
    });
    dispatch({ type: ADD_COMPANY_SUCCESS, payload: result });

    toast.success(i18n.t("company.addToast"), {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });
    return Promise.resolve();
  } catch (e) {
    dispatch({ type: ADD_COMPANY_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const deleteCompany = (id) => async (dispatch) => {
  dispatch({ type: DELETE_COMPANY_REQUEST });
  try {
    const result = await adapter({
      url: `/company/${id}`,
      method: "DELETE",
      headers: with_auth(),
    });
    dispatch({ type: DELETE_COMPANY_SUCCESS, payload: result });
    return Promise.resolve();
  } catch (e) {
    dispatch({ type: DELETE_COMPANY_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const refreshMobileAuthorizeToken = (id) => async (dispatch) => {
  dispatch({ type: REFRESH_MOBILE_AUTHORIZE_TOKEN_REQUEST });
  try {
    await adapter({
      url: `/company/refresh-mobile-authorize-token/${id}`,
      method: "PUT",
      headers: with_auth(),
    }).then(() =>
      toast.success(i18n.t("swal.success"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
      })
    );
    dispatch({ type: REFRESH_MOBILE_AUTHORIZE_TOKEN_SUCCESS });
    return Promise.resolve();
  } catch (e) {
    dispatch({
      type: REFRESH_MOBILE_AUTHORIZE_TOKEN_FAIL,
      payload: e.data.Status,
    });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};
